// Landscape preferences
// --------------------------------------------------------
// Settings => LANDSCAPE configuration
// Preferences => user LANDSCAPE preferences
// Global Preferences => user GLOBAL preferences

import api from '@/lib/api'
import {Order, ListView} from '@/lib/definitions'

const SETTINGS = {
  requiredTagsTopic: false,
  requiredTagsFeed: false,
  requiredTagsFeedSource: false
}
const SETTINGS_KEYS = Object.keys(SETTINGS)
const PREFERENCES = {
  topicsFilter: [],
  topicsFavorite: false,
  topicsOrder: Order.ACTIVITY,
  topicsView: ListView.CARD_VIEW,
  feedsView: ListView.CARD_VIEW,
  feedsTypeFilter: [],
  feedsSortBy: '',
  sourcesOrder: Order.TITLE,
  sourcesFilterDate: 'all',
  showSourceAnalysis: false,
  tagsSortBy: ''
}
const PREFERENCES_KEYS = Object.keys(PREFERENCES)
const GLOBAL_PREFERENCES = {
  iOSPromptAllowed: true,
  popupTutorialsAllowed: true,
  landscapesSortBy: '',
  landscapesFilterFavorite: false,
  homeHideCards: false,
  homeLandscapesSortBy: '',
  homeLandscapesFilterFavorite: false
}
const GLOBAL_PREFERENCES_KEYS = Object.keys(GLOBAL_PREFERENCES)

const state = {
  settings: Object.assign({}, SETTINGS),
  preferences: Object.assign({}, PREFERENCES),
  userPreferences: Object.assign({}, GLOBAL_PREFERENCES)
}

const getters = SETTINGS_KEYS.concat(GLOBAL_PREFERENCES_KEYS)
  .concat(PREFERENCES_KEYS)
  .reduce((obj, key) => {
    let prefs = 'preferences'
    if (GLOBAL_PREFERENCES_KEYS.includes(key)) prefs = 'userPreferences'
    else if (SETTINGS_KEYS.includes(key)) prefs = 'settings'
    obj[key] = state => state[prefs][key]
    return obj
  }, {})

const mutations = {
  reset(state) {
    state.settings = Object.assign({}, SETTINGS)
    state.preferences = Object.assign({}, PREFERENCES)
  },
  save(state, preferences) {
    Object.keys(preferences).forEach(key => {
      if (PREFERENCES_KEYS.includes(key)) {
        state.preferences[key] = preferences[key]
      } else if (GLOBAL_PREFERENCES_KEYS.includes(key)) {
        state.userPreferences[key] = preferences[key]
      } else if (SETTINGS_KEYS.includes(key)) {
        state.settings[key] = preferences[key]
      }
      // else ignore other keys as they belong somewhere else (insight prefs, premises prefs, etc)
    })
  }
}

const actions = {
  save({commit, rootGetters}, payload) {
    const landscapeId = rootGetters.currentLandscapeId
    commit('save', payload)
    if (payload.noPersistent) return
    let endpoint
    Object.keys(payload).forEach(key => {
      if (PREFERENCES_KEYS.includes(key)) {
        endpoint = `/landscapes/${landscapeId}/preferences`
      } else if (GLOBAL_PREFERENCES_KEYS.includes(key)) {
        endpoint = `/users/preferences`
      } else if (SETTINGS_KEYS.includes(key)) {
        endpoint = `/landscapes/${landscapeId}/settings`
      } else {
        throw new Error('preferences/save => invalid key: ' + key)
      }
    })
    return api.call('patch', endpoint, payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
